import { render, staticRenderFns } from "./lhc_ball.vue?vue&type=template&id=96bb04fc&"
import script from "./lhc_ball.vue?vue&type=script&lang=js&"
export * from "./lhc_ball.vue?vue&type=script&lang=js&"
import style0 from "./lhc_ball.vue?vue&type=style&index=0&id=96bb04fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports